module.exports = __webpack_public_path__ + "img/gb6176.prt.818451e5.jpg";